import { memo } from 'react';
import { Box } from '@chakra-ui/react';

import MultiDimensionTableOpzV2 from 'pages/PlanPageDetailsOPZ/Inputs/IndicatorPageMultiDim/MultiDimensionTableOpzV2';

import './BuilderModeMultiDimTableV1.scss';

export interface BuilderModeMultiDimTableV1Properties {
  isPercentage: string;
  refetchRequest: () => void;
}

const BuilderModeMultiDimTableV1 = memo(
  ({ isPercentage, refetchRequest }: BuilderModeMultiDimTableV1Properties) => (
    <Box
      className='builder-mode-v1-multidim-table'
      w='100%'
      flex='1'
      minH={0}
      h='100%'
      display='flex'
      flexDirection='column'
      overflow='hidden'
    >
      <MultiDimensionTableOpzV2
        refetchRequest={refetchRequest}
        isPercentage={isPercentage}
        isBuilderMode
        isBuilderModeV1
      />
    </Box>
  ),
);

BuilderModeMultiDimTableV1.displayName = 'BuilderModeMultiDimTableV1';

export default BuilderModeMultiDimTableV1;
